import { Controller } from "@hotwired/stimulus"

// A folded section still submits its fields, so an error inside it would be
// invisible. Open the section whenever it holds an invalid control, either from
// a server re-render (`field_with_errors`) or from native browser validation.
// The fields counted in the title badge are highlighted so they can be found
// once the section is open.
export default class extends Controller {
  static values = { missingFields: Array }

  connect () {
    if (this.element.querySelector(".field_with_errors")) this.open()
    this.highlightMissingFields()

    this.revealInvalid = () => this.open()
    this.element.addEventListener("invalid", this.revealInvalid, true)
  }

  disconnect () {
    this.element.removeEventListener("invalid", this.revealInvalid, true)
  }

  open () {
    this.element.open = true
  }

  highlightMissingFields () {
    this.missingFieldsValue.forEach((fieldId) => {
      const label = this.element.querySelector(`label[for="${fieldId}"]`)

      label?.closest(".form-group")?.classList.add("form-group--missing")
    })
  }
}
